module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/sakae_point3_4-0bafbcb96c9fee1b4e7321a2f6bed61d.jpg";